import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  CircularProgress,
  Typography,
  Paper,
  Alert
} from '@mui/material';
import axios from 'axios';

const CheckIn = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const validateAndRedirect = async () => {
      try {
        // Validate the check-in token
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || 'https://events.the9designs.com/api/v1'}/checkin/${token}`
        );

        if (response.data.success) {
          // Redirect to QR scan page to complete check-in
          // Pass the token as a query parameter for the scanner to use
          navigate(`/usher/qr-scan?token=${token}`, { replace: true });
        }
      } catch (err) {
        console.error('Check-in validation error:', err);
        setError(err.response?.data?.message || 'Invalid or expired check-in link');
        setLoading(false);
      }
    };

    if (token) {
      validateAndRedirect();
    } else {
      setError('No check-in token provided');
      setLoading(false);
    }
  }, [token, navigate]);

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <Typography variant="h6" gutterBottom>
            Validating Check-In Link...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while we verify your check-in link
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Alert severity="error">
          <Typography variant="h6" gutterBottom>
            Check-In Failed
          </Typography>
          <Typography variant="body2">
            {error}
          </Typography>
        </Alert>
      </Paper>
    </Container>
  );
};

export default CheckIn;
